import { EAcceptedMimeTypes } from '../constants';

export const validateMimeType = (mimeType: string) => {
  return Object.values<string>(EAcceptedMimeTypes).includes(mimeType);
};
